import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MortgageJourneyApp from './mortgageJourney/MortgageJourneyApp';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isPaydownHost = [
  'paydown.resetandrun.com.au',
  'paydown.resetandrest.com.au',
  'resetandrun-paydown-dev.pages.dev',
].includes(window.location.hostname);

const isMortgageJourneyRoute =
  isPaydownHost ||
  window.location.pathname.startsWith('/dev/mortgage-journey') ||
  window.location.pathname.startsWith('/mortgage-journey-dev');

root.render(
  <React.StrictMode>
    {isMortgageJourneyRoute ? <MortgageJourneyApp /> : <App />}
  </React.StrictMode>
);
